import type { FC, PropsWithChildren } from 'react';
import { Modal, ModalForm, InputsSection, InputBox, ModalButtons } from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import DeleteModalSkeleton from '../../Skeletons/DeleteModalSkeleton';
import { IRTMTimeLog } from '../../hooks/rtm_time_log/index.type';

export type DeleteModalState = PropsWithChildren<{
  status: boolean;
  data?: IRTMTimeLog;
}>;

export type IdeleteModalStates = PropsWithChildren<{
  name: { value: string; error: string };
}>;

type AddEditModalProps = PropsWithChildren<{
  loading: boolean;
  deleteModal: DeleteModalState;
  deleteModalStates: IdeleteModalStates;
  setDeleteModalStates: React.Dispatch<React.SetStateAction<IdeleteModalStates>>;
  onCloseModal?: () => void;
  handleDelete?: (event: React.FormEvent<HTMLFormElement>) => void;
}>;

const DeleteModal: FC<AddEditModalProps> = props => {
  return (
    <Modal show={props.deleteModal.status}>
      <ModalHeading heading={`Delete assign plan`} />
      {props.loading ? (
        <DeleteModalSkeleton />
      ) : (
        props.deleteModal.data && (
          <ModalForm style={{ marginBottom: '2.5rem' }} onSubmit={props.handleDelete}>
            <InputsSection style={{ width: '34rem', flexWrap: 'wrap' }}>
              <p className='dangerText'>Please note that this will delete Assign Plan entire data and will not be restored in future.</p>
            </InputsSection>
            <ModalButtons submitButtonLabel='Delete' cancelButtonLabel='Cancel' onCancel={props.onCloseModal} />
          </ModalForm>
        )
      )}
    </Modal>
  );
};

export default DeleteModal;
